




















































import { Component, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import pdf from "vue-pdf";
import { GetKnowledgeFileType } from "@/api/pdOutPatient/pdEducation/pdKnowledge";
import { UpdatePatientEducationPlanDetail} from "@/api/pdEducationPlan/pdPatientEducationPlan";
@Component({
  components: {
    pdf
  }
})
export default class PdEducationPlanPlay extends AbpBase {
  @Prop() pdEducationPlay: any;
  Education: any = {};
  baseUrl : string = `http://${location.hostname}:${SERVER_PORT}`;
  fileType: any = "";
  currentPage = 0;
  pageCount = 0;
  rules = {};

  @Watch("pdEducationPlay", { immediate: false, deep: true })
  async onKnowledeChanged() {
    if (this.pdEducationPlay) {
      var newObj = Object.assign({}, this.pdEducationPlay);
      this.Education = newObj;
      if(this.Education.finish_Time!=null){
        this.Education.finish_Time = new Date(this.Education.finish_Time)
      }else{
        this.Education.finish_Time=new Date();
      }
          console.log(this.Education)
      var res = await GetKnowledgeFileType(this.Education.fileName);
      this.fileType = res.objects;
    }
  }
  handlePageChange(val: any) {
    this.currentPage = val;
  }
  loadPdfHandler(e) {
    this.currentPage = 1; // 加载的时候先加载第一页
  }

  handleExport() {
    var elemIF = document.createElement("iframe");
    elemIF.src =this.baseUrl+this. Education.url;
    elemIF.name = this.Education.fileName;
    elemIF.style.display = "none";
    document.body.appendChild(elemIF);
  }

  async submit() {
    let validResult = false;
    this.$refs["form"].validate(valid => {
      if (valid) {
        validResult = true;
      }
    });
    if (validResult) {
        await UpdatePatientEducationPlanDetail(this.Education);
      return true;
    }

    return false;
  }

  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdPatientEducationPlan/pdPreviousEducationPlay.vue